export const isValidateKeyboard = ({ keyCode }) => [13, 32].includes(keyCode);
export const isEscapeKeyboard = ({ keyCode }) => keyCode === 27;
